<template>
  <el-dialog
    title="投放渠道"
    width="40%"
    :visible.sync="visible"
    :before-close="handleClose"
    append-to-body
  >
    <el-form
      ref="formRef"
      :model="formInfo"
      label-width="120px"
      label-position="right"
      size="small"
      v-loading="loading"
      :rules="formRules"
    >
      <el-form-item label="渠道代码" prop="code">
        <el-input
          v-model="formInfo.code"
          placeholder="渠道代码"
          clearable
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="渠道名称" prop="title">
        <el-input
          v-model="formInfo.title"
          placeholder="渠道名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="小程序码" prop="image" v-show="!formInfo.isNew">
        <img :src="formInfo.image" class="avatar" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { saveActivityChannelApi } from "@/api/activity";
export default {
  name: "BizChannelInfo",
  data() {
    return {
      visible: false,
      loading: false,
      formInfo: {},
      formRules: {
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    open(item) {
      this.visible = true;
      this.formInfo = item;
    },
    handleClose() {
      this.visible = false;
      this.$refs.formRef.resetFields();
      this.formInfo = {};
    },
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveFormData();
        }
      });
    },
    saveFormData() {
      var item = { ...this.formInfo };
      this.loading = true;
      saveActivityChannelApi(item)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.handleClose();
            const { id, title, image } = resp.data.results;
            item.id = id;
            item.title = title;
            item.image = image;
            console.log(item);
            this.$emit("refresh", item);
          } else {
            this.$message.error(resp.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// info.vue?60e0e4fd